import * as actionTypes from './actions-types';

export const setDrawerState = (open) => {
    return {
        type: actionTypes.SET_DRAWER_STATE,
        openState: open,
    };
};
